/**
 * Session expiry is enforced by the BFF on protected requests. The browser
 * only reacts to a terminal 401; it must not maintain an independent timer or
 * offer a refresh path that can revive an expired server session.
 */
export function SessionDialogs() {
  return null;
}
